module.exports = __webpack_public_path__ + "img/KarroFin-on-dark.77f70327.svg";